<template>
  <div class="mt-6 p-lg-6 p-3">
    <h3 class="text-secondary font-weight-light text-center"> {{ $t("common.welcome_screen.congratulations") }} 🎉</h3>
    <p class="mt-4 text-secondary">Your company "{{companyName}}" just created! It's time to invite first team members:</p>
    <div
      v-for="(invite, idx) in invites"
      :key="`invite_${idx}`"
      class="form-group">
      <input type="text" v-model="invite.email"  class="form-control" :placeholder="$t('common.welcome_screen.enter_member_s_email')" autofocus>
      <div class="custom-control mt-2 custom-switch">
        <input type="checkbox" class="custom-control-input float-right" v-model="invite.is_admin" :id="'invalidCheck'+idx">
        <label :class="{'text-muted': !invite.is_admin}" class="custom-control-label float-right" :for="'invalidCheck'+idx">{{ $t("common.welcome_screen.make_manager") }}</label>
      </div>
    </div>
    <div class="text-center">
      <button @click="addInvite" class="btn btn-sm btn-link text-secondary"><i class="fe fe-plus-circle"></i> {{ $t("common.welcome_screen.add_invite") }}</button>
      <button @click="removeLastInvite" :disabled="invites.length <= 1" class="btn btn-sm btn-link text-secondary"><i class="fe fe-trash-2"></i> {{ $t("common.welcome_screen.remove_last_invite") }}</button>
    </div>
    <button @click="sendInvites" class="btn btn-sm btn-primary mt-4 float-right">{{ $t("common.welcome_screen.send_invitation_emails") }} <i class="fe fe-arrow-right"></i></button>
    <button @click="skipCompanyInvite" class="btn text-muted btn-sm btn-link mt-4  float-right mr-2">Skip</button>
  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  import { sendInvitations } from '../../../api/authApi';

  export default {
    name: 'CompanyInviteStep',
    mixins: [AuthStepsMixin],
    data () {
      return {
        invites: [
          { email: '', first_name: '', last_name: '', is_admin: false },
          { email: '', first_name: '', last_name: '', is_admin: false },
          { email: '', first_name: '', last_name: '', is_admin: false },
        ],
      };
    },
    props: {
      companyName: {
        default: '',
      },
    },
    methods: {
      addInvite: function () {
        this.invites.push({ email: '', first_name: '', last_name: '', is_admin: false });
      },
      removeLastInvite: function () {
        this.invites.splice(-1, 1);
      },
      sendInvites: async function () {
        const ok = await sendInvitations(this.invites);
        if (ok) {
          this.$noty.show('Invites were scheduled to be send');
          this.emitStep('finish');
        }
        this.emitStep('finish');
      },
      skipCompanyInvite: function () {
        this.emitStep('finish');
      },
    },
  };
</script>

<style scoped>

</style>
